import type { I18nValue } from './I18nProvider';

const MONTHS_IN_YEAR = 12;

/**
 * A child's age in words, «سنتان و3 أشهر», each part in its own plural form (GAPS E24). A part that is zero is left
 * out, so a baby reads «5 أشهر» and a third birthday «3 سنوات».
 */
export function formatAge(months: number, { t, tn }: Pick<I18nValue, 't' | 'tn'>): string {
  const years = Math.floor(months / MONTHS_IN_YEAR);
  const rest = months % MONTHS_IN_YEAR;
  if (years === 0) return tn('age.months', rest);
  if (rest === 0) return tn('age.years', years);
  return t('age.both', { years: tn('age.years', years), months: tn('age.months', rest) });
}
